import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TAFsSvgComponent } from './tafs-svg/tafs-legend-svg';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';

export const TAFS_LEGEND: TwcLegendParams = {
  title: 'TAFS',
  legendTitleBarInfo: signal('0'),
  data: {
    svgComponent: TAFsSvgComponent,
    showTimeSpanSelectForSingleOption: true
  },
  legendComponent: TwcLegendComponent
};
